<template>
  <transition-expand-height>
    <ul v-show="show" :class="[`form__errors`, `errors`]">
      <li class="errors__item small">{{ serverError || error }}</li>
    </ul>
  </transition-expand-height>
</template>

<script>
// Services
import { arrayLoop } from 'services/array';

// Transitions
import TransitionExpandHeight from 'transitions/ExpandHeight';

// Export
export default {
  name: `module-form-errors`,

  // Components
  components: {
    TransitionExpandHeight,
  },

  // Props
  props: {
    serverError: String,
    errors: Object,
    messages: Object,
    label: {
      type: String,
      default: `This field`,
    },
  },

  // Data
  data() {
    return {
      hasErrors: false,
      error: `${this.label} is invalid`,
    };
  },
  computed: {
    show() {
      return this.serverError || this.hasErrors;
    },
  },
  watch: {
    errors: {
      handler(errors) {
        const label = this.label;
        const params = errors.$params || {};
        const min = (params.min || {}).min || 0;
        const max = (params.max || {}).max || 0;
        const minLength = (params.minLength || {}).min || 0;
        const maxLength = (params.maxLength || {}).max || 0;

        const map = {
          required: `Required`,
          url: `Invalid URL`,
          email: `Invalid email`,
          min: `${min} min.`,
          minLength: `${label} must contain at least ${minLength} characters`,
          max: `${max} max.`,
          maxLength: `${maxLength} character(s) max.`,
          match: `Fields do not match`,
        };

        let error = ``;

        const messages = this.messages || {};

        arrayLoop(map, (key, msg) => {
          if (errors[key] === false && !error) {
            error = messages[key] || msg;
          }
        });

        if (errors.$error) {
          this.error = error || `${label} is invalid`;
          this.hasErrors = true;
        } else {
          this.hasErrors = false;
        }
      },
      deep: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// Errors.vue?3e93ac98